var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResetGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4225_1087",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4225_1087)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0419 16.4583C8.2395 16.4583 6.70561 15.8312 5.4402 14.5769C4.17464 13.3226 3.54186 11.7969 3.54186 9.99999V9.34936L2.0002 10.891L1.12207 10.0129L4.16686 6.96791L7.21165 10.0129L6.33353 10.891L4.79186 9.34936V9.99999C4.79186 11.4476 5.30145 12.6776 6.32061 13.69C7.33992 14.7022 8.58033 15.2083 10.0419 15.2083C10.387 15.2083 10.7318 15.1707 11.0762 15.0954C11.4208 15.02 11.7571 14.907 12.0852 14.7564L13.0227 15.6939C12.5537 15.946 12.0694 16.1364 11.57 16.2652C11.0704 16.3939 10.561 16.4583 10.0419 16.4583ZM15.8335 13.0321L12.7887 9.98707L13.6669 9.10895L15.2085 10.6506V9.99999C15.2085 8.55235 14.6989 7.32235 13.6798 6.30999C12.6605 5.29777 11.4201 4.79166 9.95853 4.79166C9.61339 4.79166 9.2686 4.8293 8.92415 4.90457C8.57957 4.97999 8.24325 5.09298 7.9152 5.24353L6.9777 4.30603C7.44672 4.05395 7.93096 3.86353 8.4304 3.73478C8.92999 3.60603 9.43936 3.54166 9.95853 3.54166C11.7609 3.54166 13.2948 4.16881 14.5602 5.42311C15.8258 6.67742 16.4585 8.20305 16.4585 9.99999V10.6506L18.0002 9.10895L18.8783 9.98707L15.8335 13.0321Z",
    fill: "#409958"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetGreen);
export default __webpack_public_path__ + "static/media/reset-green.8871e30e51b09351e67280e7107f852c.svg";
export { ForwardRef as ReactComponent };